<template>
  <div class="bg-gray-300 px-6 m-3 text-gray-800 max-w-4xl mx-auto mt-3">
    <h1 class="text-3xl font-bold mb-10 text-center">Datenschutzerklärung</h1>

    <!-- 1. Datenschutz auf einen Blick -->
    <section class="bg-white rounded-xl shadow p-6 mb-6">
      <h2 class="text-xl font-semibold mb-2">1. Datenschutz auf einen Blick</h2>
      <p class="text-gray-700">
        Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
      </p>
    </section>

    <!-- 2. Verantwortlicher -->
    <section class="bg-white rounded-xl shadow p-6 mb-6">
      <h2 class="text-xl font-semibold mb-2">2. Verantwortlicher</h2>
      <p class="text-gray-700">Verantwortlich für die Datenverarbeitung auf dieser Website ist:</p>
      <p class="mt-2 text-gray-700">
        Thorsten Kasel<br />
        Hanielstr. 8 A<br />
        47119 Duisburg – Ruhrort<br />
        E-Mail: <a href="mailto:kontakt@thorsten-kasel.de" class="text-gray-800 hover:underline">kontakt@thorsten-kasel.de</a>
      </p>
    </section>

    <!-- 3. Erhebung und Speicherung personenbezogener Daten -->
    <section class="bg-white rounded-xl shadow p-6 mb-6">
      <h2 class="text-xl font-semibold mb-2">3. Erhebung und Speicherung personenbezogener Daten</h2>
      <p class="text-gray-700">
        Beim Besuch dieser Website werden keine personenbezogenen Daten automatisch erfasst, außer es werden aktiv Informationen über ein Kontaktformular oder per E-Mail übermittelt.
      </p>
    </section>

    <!-- 4. Server-Log-Dateien -->
    <section class="bg-white rounded-xl shadow p-6 mb-6">
      <h2 class="text-xl font-semibold mb-2">4. Server-Log-Dateien</h2>
      <p class="text-gray-700">
        Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch übermittelt. Dies sind:
      </p>
      <ul class="list-disc list-inside mt-2 text-gray-700">
        <li>Browsertyp und Browserversion</li>
        <li>Verwendetes Betriebssystem</li>
        <li>Referrer URL</li>
        <li>Hostname des zugreifenden Rechners</li>
        <li>Uhrzeit der Serveranfrage</li>
        <li>IP-Adresse</li>
      </ul>
      <p class="mt-2 text-gray-700">Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.</p>
    </section>

    <!-- 5. Rechte der betroffenen Person -->
    <section class="bg-white rounded-xl shadow p-6 mb-6">
      <h2 class="text-xl font-semibold mb-2">5. Rechte der betroffenen Person</h2>
      <p class="text-gray-700">Sie haben jederzeit das Recht auf:</p>
      <ul class="list-disc list-inside mt-2 text-gray-700">
        <li>Auskunft über Ihre gespeicherten personenbezogenen Daten</li>
        <li>Berichtigung unrichtiger Daten</li>
        <li>Löschung Ihrer Daten, soweit keine gesetzliche Aufbewahrungspflicht besteht</li>
        <li>Einschränkung der Verarbeitung</li>
        <li>Widerspruch gegen die Verarbeitung</li>
        <li>Datenübertragbarkeit</li>
        <li>Beschwerde bei der zuständigen Aufsichtsbehörde</li>
      </ul>
    </section>

    <!-- 6. Kontaktaufnahme -->
    <section class="bg-white rounded-xl shadow p-6 mb-6">
      <h2 class="text-xl font-semibold mb-2">6. Kontaktaufnahme</h2>
      <p class="text-gray-700">
        Wenn Sie uns per E-Mail kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten zum Zwecke der Bearbeitung Ihres Anliegens gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
      </p>
    </section>

    <!-- 7. SSL / TLS -->
    <section class="bg-white rounded-xl shadow p-6 mb-6">
      <h2 class="text-xl font-semibold mb-2">7. SSL- bzw. TLS-Verschlüsselung</h2>
      <p class="text-gray-700">
        Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://“ auf „https://“ wechselt.
      </p>
    </section>

    <!-- 8. Aktualität -->
    <section class="bg-white rounded-xl shadow p-6 mb-6">
      <h2 class="text-xl font-semibold mb-2">8. Aktualität und Änderung dieser Datenschutzerklärung</h2>
      <p class="text-gray-700">
        Diese Datenschutzerklärung ist aktuell gültig und hat den Stand September 2025. Wir behalten uns vor, sie bei Änderungen der Rechtslage oder bei Änderungen unserer Website entsprechend anzupassen.
      </p>
    </section>

    <!-- Entwickler -->
    <section class="bg-white rounded-xl shadow p-6">
      <h2 class="text-xl font-semibold mb-2">Webentwicklung</h2>
      <p class="text-gray-700">
        Tobias Kubina – VelWebSolutions<br />
        Einzelunternehmer / Freelancer<br />
        Gubener Str. 14<br />
        47829 Krefeld<br />
        Deutschland<br />
        E-Mail: <a href="mailto:info@velwebsolutions.de" class="text-gray-800 hover:underline">info@velwebsolutions.de</a><br />
        Telefon: <a href="tel:+4917632544620" class="text-gray-800 hover:underline">+49 176 32544620</a>
      </p>
    </section>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped>
/* Dezentes, modernes Karten-Layout für alle Abschnitte */
</style>
